/*
 * @Copyright:
 * -----------------------------------------------------------------------------------
 *  Kingsoft Office Enterprise Cloud Services.
 *  Copyright (c) Kingsoft Office,All rights reserved.
 * -----------------------------------------------------------------------------------
 *
 * @Date: 2020-08-24 17:51:03
 * @Author: Kaven.D
 * @LastEditors: Kaven.D
 * @LastEditTime: 2020-09-24 11:36:49
 * @Description:
 */
import mutations from './mutations'
import actions from './actions'
import { COMAPNYLIST, ADMINCOMAPNYLIST, ACTIVE_AMOUNT } from './constants'

export interface CompanyList {
  ctime: number
  ctype: string
  domain: string
  file_corp_icon: string
  id: number
  is_default_icon: boolean
  logo: string
  name: string
  phone: string
  status: string
}

export interface CompanyState {
  COMPANY_COMPANYLIST: CompanyList[] | null
  COMPANY_ADMINCOMAPNYLIST: CompanyList[] | null
  COMPANY_ACTIVE_AMOUNT: number
}

export const createCompanyState = (): CompanyState => {
  return {
    [COMAPNYLIST]: null,
    [ADMINCOMAPNYLIST]: null,
    [ACTIVE_AMOUNT]: 0,
  } as unknown as CompanyState
}
export default {
  state: createCompanyState(),
  actions,
  mutations,
}
